/* Kleine Settings-Loader, die beim App-Start gebraucht werden.
   Eigenes Modul, damit App.js nicht das komplette SettingsModal
   (größte Komponente im Bundle) statisch importieren muss. */

const AUTO_WV_KEY = 'crm_auto_wiedervorlage_settings';

export function loadAutoWiedervorlageSettings() {
  try {
    const s = localStorage.getItem(AUTO_WV_KEY);
    if (s) return { enabled: true, days: 3, lists: [], ...JSON.parse(s) };
  } catch {}
  return { enabled: true, days: 3, lists: [] };
}

export function saveAutoWiedervorlageSettings(cfg) {
  try { localStorage.setItem(AUTO_WV_KEY, JSON.stringify(cfg)); } catch {}
}

export function loadBestandskunden() {
  try {
    const s = localStorage.getItem('crm_bestandskunden');
    if (s) return JSON.parse(s);
  } catch {}
  return [];
}

export function saveBestandskunden(list) {
  try { localStorage.setItem('crm_bestandskunden', JSON.stringify(list)); } catch {}
}
